import { CSSProperties } from 'react'
import { Wrapper, MobileContent, DesktopContent } from './HappyHour.styles'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'

type HappyHourProps = {
  content: string
  mobileContent?: string
  style?: CSSProperties
}
const HappyHour: React.FC<HappyHourProps> = ({ content, mobileContent, style }) => {
  // FIXME: using content for both mobile and desktop; mobileContent is coming through incorrectly
  return (
    <Wrapper style={style}>
      {mobileContent && (
        <MobileContent data-testid="happy-hour-mobile">
          <ReactMarkdown rehypePlugins={[rehypeRaw]}>{content}</ReactMarkdown>
        </MobileContent>
      )}
      <DesktopContent responsive={!mobileContent} data-testid="happy-hour-desktop">
        <ReactMarkdown rehypePlugins={[rehypeRaw]}>{content}</ReactMarkdown>
      </DesktopContent>
    </Wrapper>
  )
}

export default HappyHour
